import React from 'react';
import youtubeLogo from '../../assets/youtube-logo.png';

/**
 * Slim, theme-matching compliance footer shown app-wide (login + dashboard).
 * Uses fixed positioning so it never disturbs existing page layouts.
 * Surfaces the YouTube API Services compliance links + YouTube branding.
 */
const linkStyle = {
  color: '#5b6478',
  textDecoration: 'none',
  fontSize: '12px',
  lineHeight: 1,
  whiteSpace: 'nowrap',
};

const sep = (
  <span style={{ color: '#c7ccd6', fontSize: '12px' }} aria-hidden="true">
    |
  </span>
);

const ComplianceFooter = () => {
  // This footer is rendered app-wide, including on routes that other parts of the
  // app embed inside an <iframe> (e.g. PlannerV2 embeds /competitor-report-dashboard).
  // Skip it inside an iframe so it doesn't duplicate the outer page's own footer.
  const isInIframe = window.self !== window.top;
  if (isInIframe) return null;

  return (
    <div
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1100,
        background: '#ffffff',
        borderTop: '1px solid #e4e7ef',
        boxShadow: '0 -1px 6px rgba(17,25,54,0.05)',
        padding: '7px 16px',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        fontFamily: "'Inter', -apple-system, 'Segoe UI', Roboto, system-ui, sans-serif",
      }}
    >
      <a style={linkStyle} href="/privacy-policy">
        Privacy Policy
      </a>
      {sep}
      <a style={linkStyle} href="/terms">
        Terms
      </a>
      {sep}
      <a style={linkStyle} href="https://www.youtube.com/t/terms" target="_blank" rel="noopener noreferrer">
        YouTube Terms of Service
      </a>
      {sep}
      <a style={linkStyle} href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
        Google Privacy Policy
      </a>
      {sep}
      <a
        style={linkStyle}
        href="https://myaccount.google.com/permissions"
        target="_blank"
        rel="noopener noreferrer"
      >
        Google Security Settings
      </a>
      <a
        href="https://www.youtube.com/channel/UCG9I7TOp2GJ22fRbIzz0vxw"
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: 'inline-flex', alignItems: 'center', marginLeft: '4px' }}
        aria-label="Influencer.in on YouTube"
      >
        <img src={youtubeLogo} alt="YouTube" style={{ height: '16px', display: 'block' }} />
      </a>
    </div>
  );
};

export default ComplianceFooter;
